<div class="sorting">
  <p class="sorting__label">Sorting rules</p>
  <div class="sorting__list" cdkDropList (cdkDropListDropped)="drop($event)">
    @for (rule of sortingArray.controls; track rule; let index = $index; let count = $count) {
      <div
        class="sorting__list--item"
        cdkDrag
        cdkDragBoundary=".sorting__list"
        [cdkDragDisabled]="count === 1"
        cdkDragPreviewContainer="parent">
        <app-sorting-item
          [sortingGroup]="rule"
          [treeNodes]="treeNodes"
          [type]="type"
          (ruleDeleted)="deleteRule(index)"></app-sorting-item>
        <div class="sorting__list--placeholder" *cdkDragPlaceholder></div>
      </div>
    } @empty {
      <div class="sorting__list--empty">No sorting rules added yet</div>
    }
  </div>
  <button class="sorting__add-rule" mat-stroked-button (click)="addRule()">Add sorting rule</button>
</div>
